var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { RadioGroup } from './RadioGroup';
import { RadioButton } from './RadioButton';
import { RadioContent } from './RadioContent';
import { LabelTag, SpanTag, InputTag } from '../../Utils/AtomicTag';
import Transition from '../../components/Transition';
var Radio = /** @class */ (function (_super) {
    __extends(Radio, _super);
    function Radio(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (e) {
            var checked = e.target.checked;
            var _a = _this.props, value = _a.value, onRadioChange = _a.onRadioChange;
            onRadioChange && onRadioChange(value, e);
            if (!('checked' in _this.props)) {
                _this.setState({
                    checked: checked,
                });
            }
        };
        var checked = 'checked' in props ? props.checked : props.defaultChecked;
        _this.state = {
            checked: checked,
        };
        return _this;
    }
    Radio.getDerivedStateFromProps = function (props, state) {
        if ('checked' in props) {
            return __assign(__assign({}, state), { checked: props.checked });
        }
        return null;
    };
    Radio.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, value = _a.value, children = _a.children, style = _a.style, className = _a.className, checked = _a.checked, defaultChecked = _a.defaultChecked, onRadioChange = _a.onRadioChange, rest = __rest(_a, ["disabled", "value", "children", "style", "className", "checked", "defaultChecked", "onRadioChange"]);
        var radioProps = __assign({ checked: this.state.checked, disabled: disabled, onChange: this.handleChange, value: value }, rest);
        return (React.createElement(LabelTag, { name: Radio.NAME, atomics: [
                'relative',
                'text-sm',
                'cursor-pointer',
                'outline-none',
                'inline-flex',
                'items-center',
                'whitespace-no-wrap',
            ], style: style, className: className + " " + (this.state.checked ? 'legao-radio-checked' : '') + " " + (disabled ? 'legao-radio-disabled' : '') },
            React.createElement(Transition, { in: checked, unmountOnExit: false, classNames: "click-radio-animating", timeout: 500 },
                React.createElement(SpanTag, { atomics: ['relative', 'top-0', 'left-0', 'inline-block', 'items-center'], className: "legao-radio-inner" })),
            React.createElement(InputTag, __assign({ atomics: ['absolute', 'left-0', 'top-0', 'bottom-0', 'right-0', 'opacity-0', 'z-50'], type: "radio" }, radioProps)),
            React.createElement(SpanTag, { atomics: ['pl-2', 'pr-4'], className: "legao-radio-content" }, children)));
    };
    Radio.Group = RadioGroup;
    Radio.Button = RadioButton;
    Radio.Content = RadioContent;
    Radio.defaultProps = {
        className: '',
        disabled: false,
        value: '',
        defaultChecked: false,
        name: 'radio',
        marquee: 'font',
    };
    Radio.NAME = 'radio';
    Radio.displayName = 'Radio';
    return Radio;
}(PureComponent));
export { Radio };
